import React from 'react';
import classNames from 'classnames';
import config from 'react-global-configuration';

import './style.scss';

import {
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import { Button } from '../../../../components';

const Paragraph = ({ entity, className }) => {
  const API_URL = config.get('API_URL');
  const classes = classNames('Paragraph MPItem', className);
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_text', 0, 'processed']);
  const imageSource = entity.getIn(['field_image', 0, 'source']);
  const imageAlt = entity.getIn(['field_image', 0, 'title']);
  const link = entity.getIn(['field_link', 0]);

  return (
    <div className={classes}>
      <div className="MPItem__shape">
        <img src={`${API_URL}${imageSource}`} alt={imageAlt} />
        <h2 className="MPItem__title">{title}</h2>
      </div>
      <WysiwygField
        property="schema:text"
        className="MPItem__text"
        html={body}
      />
      {link && (
        <Button href={link.get('alias')} secondary className="MPItem__button">
          {link.get('title')}
        </Button>
      )}
    </div>
  );
};

export default Paragraph;
